import { getCookie, setCookie } from 'cookies-next'
import { v4 as uuid } from 'uuid'

const DEVICE_ID_STORAGE_KEY = 'guru-device-id'

export const getDeviceId = (ctx): string => {
  const { req, res } = ctx
  const appDeviceId = req.headers['device-id'] || ''

  if (Boolean(appDeviceId)) {
    setCookie(DEVICE_ID_STORAGE_KEY, appDeviceId, {
      req,
      res,
      maxAge: 60 * 60 * 24 * 365, // 1 year
    })
    return appDeviceId
  }

  const deviceIdFromCookie = getCookie(DEVICE_ID_STORAGE_KEY, { req, res })

  if (Boolean(deviceIdFromCookie)) {
    return deviceIdFromCookie
  }

  const generatedDeviceId = uuid()
  setCookie(DEVICE_ID_STORAGE_KEY, generatedDeviceId, {
    req,
    res,
    maxAge: 60 * 60 * 24 * 365, // 1 year
  })
  return generatedDeviceId
}

export const DEVICE_ID_LOCAL_STORAGE_KEY = 'cur-fe-device-id'

export const getClientSideDeviceId = () => {
  if (typeof window === 'undefined') return ''

  let deviceId = window.localStorage.getItem(DEVICE_ID_LOCAL_STORAGE_KEY)

  if (!deviceId) {
    const generatedDeviceId = uuid()
    window.localStorage.setItem(DEVICE_ID_LOCAL_STORAGE_KEY, generatedDeviceId)
    deviceId = generatedDeviceId
  }

  return deviceId
}
